<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3">Stock-in Process</h3>
      <b-card class="mb-1">
        <b-row>
          <b-col cols="2">
            <strong>DN # (Optional)</strong>
          </b-col>
          <b-col cols="3">
            <b-form-input
              size="sm"
              type="text"
              placeholder
              v-model="order_master_search.dn_no"
              v-on:keyup.enter="searchOrder()"
            ></b-form-input>
          </b-col>

          <b-col>
            <b-form-checkbox
              id="checkbox-packed_by_vendor"
              v-model="order_master_search.packed_by_vendor"
              name="checkbox-packed_by_vendor"
              value="1"
              :unchecked-value="null"
            >
              Packed by Vendor
            </b-form-checkbox>
          </b-col>
        </b-row>
        <!-- </b-card>
      <b-card class="mt-1"> -->
        <b-row class="mt-2">
          <b-col cols="2" class="pr-1 center_align">
            Product SKU
          </b-col>

          <b-col cols="2" class="pl-0 pr-1 center_align">
            Lot#
          </b-col>

          <b-col cols="2" class="pl-0 pr-1 center_align">
            Description
          </b-col>

          <b-col cols="1" class="pl-0 pr-1 center_align">
            Quantity
          </b-col>

          <b-col cols="1" class="pl-0 pr-1 center_align">
            Type
          </b-col>

          <b-col cols="1" class="pl-0 pr-1 center_align">
            Location
          </b-col>

          <b-col cols="1" class="pl-0 pr-1 center_align">
            Size
          </b-col>

          <b-col cols="1" class="pl-0 pr-1 center_align">
            Weight
          </b-col>

          <b-col cols="1" class="pl-0 pr-1 center_align">
            Expiry Date
          </b-col>
        </b-row>

        <b-row
          class="mt-2"
          :key="row_product_i"
          v-for="(row_product, row_product_i) in stockin_products"
        >
          <b-col cols="2" class="pr-1">
            <b-form-input
              size="sm"
              :ref="'txt_product_sku_' + row_product_i"
              :id="'txt_product_sku_' + row_product_i"
              type="text"
              placeholder="Product SKU"
              v-model="row_product.product_sku"
              v-on:keyup.enter="lookupProductMaster(row_product, row_product_i)"
              :state="checkProductRowSKUState(row_product)"
            ></b-form-input>
          </b-col>

          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input
              size="sm"
              :ref="'txt_lot_no_' + row_product_i"
              :id="'txt_lot_no_' + row_product_i"
              type="text"
              placeholder="Lot#"
              v-model="row_product.lot_1"
              v-on:keyup.enter="lookupProductLot(row_product, row_product_i)"
              :state="checkProductRowLotState(row_product)"
            ></b-form-input>
          </b-col>

          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input
              size="sm"
              :id="'txt_description_' + row_product_i"
              type="text"
              placeholder="Description"
              v-model="row_product.product_description"
              disabled
            ></b-form-input>
          </b-col>

          <b-col cols="1" class="pl-0 pr-1">
            <b-form-input
              :ref="'txt_quantity_' + row_product_i"
              size="sm"
              :id="'txt_quantity_' + row_product_i"
              type="text"
              placeholder="Quantity"
              v-model="row_product.product_qty"
              v-on:keyup.enter="focusNextRow(row_product_i)"
            ></b-form-input>
          </b-col>

          <b-col cols="1" class="pl-0 pr-1">
            <b-form-select
              size="sm"
              v-model="row_product.inventory_type"
              :options="inventory_type_options"
            />
          </b-col>

          <b-col cols="1" class="pl-0 pr-1">
            <!-- <b-form-select
              size="sm"
              v-model="row_product.location"
              :options="location_options"
            /> -->

            <b-form-input
              size="sm"
              :ref="'txt_location_' + row_product_i"
              :id="'txt_location_' + row_product_i"
              type="text"
              placeholder="Location"
              v-model="row_product.location"
              :state="checkProductRowLocationState(row_product)"
            ></b-form-input>
          </b-col>

          <b-col cols="1" class="pl-0 pr-1 center_align">
            <b-button
              class="btn-action"
              variant="info"
              size="sm"
              @click="showModal_sizeInput(row_product, row_product_i)"
            >
              <span
                @click="showModal_sizeInput(row_product, row_product_i)"
                class="dot_green"
                v-if="
                  row_product.height_cm &&
                    row_product.width_cm &&
                    row_product.depth_cm
                "
              ></span>
              <span
                class="dot_red"
                v-if="
                  !row_product.height_cm ||
                    !row_product.width_cm ||
                    !row_product.depth_cm
                "
              ></span>
              Edit</b-button
            >
          </b-col>

          <b-col cols="1" class="pl-0 pr-1 center_align">
            <b-button
              class="btn-action"
              variant="info"
              size="sm"
              @click="showModal_weightInput(row_product, row_product_i)"
            >
              <span
                class="dot_green"
                v-if="row_product.actual_weight_kg"
                @click="showModal_weightInput(row_product, row_product_i)"
              ></span>
              <span class="dot_red" v-if="!row_product.actual_weight_kg"></span>
              Edit</b-button
            >
          </b-col>

          <b-col cols="1" class="pl-0 pr-1 center_align">
            <b-button
              class="btn-action"
              variant="info"
              size="sm"
              @click="showModal_ExpDateInput(row_product, row_product_i)"
            >
              <span
                class="dot_green"
                v-if="!(!row_product.expiration_date || row_product.expiration_date == null || row_product.expiration_date == '0000-00-00' || row_product.expiration_date == 'Invalid date' || row_product.expiration_date == '')"
                @click="showModal_ExpDateInput(row_product, row_product_i)"
              ></span>
              <span class="dot_red" v-if="!row_product.expiration_date || row_product.expiration_date == null || row_product.expiration_date == '0000-00-00' || row_product.expiration_date == 'Invalid date' || row_product.expiration_date == ''"></span>
              Edit</b-button
            >
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mt-1 mb-1">
        <b-button
          class="mt-2 btn-action btn-block"
          variant="info"
          @click="showModal_confirmStockIn()"
          >Submit</b-button
        >
      </b-card>

      <b-modal ref="modal_sizeInput" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="3"
              ><b-form-input
                class="center_align"
                size="sm"
                type="text"
                placeholder="Height"
                v-model="updating_item.height_cm"
              ></b-form-input
            ></b-col>
            <b-col cols="3"
              ><b-form-input
                class="center_align"
                size="sm"
                type="text"
                placeholder="Width"
                v-model="updating_item.width_cm"
              ></b-form-input
            ></b-col>
            <b-col cols="3"
              ><b-form-input
                class="center_align"
                size="sm"
                type="text"
                placeholder="Depth"
                v-model="updating_item.depth_cm"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_sizeInput"
            >Cancel</b-btn
          >
          <b-btn class="mt-3" variant="outline-success" @click="sizeInput()"
            >OK</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_weightInput" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="3"
              ><b-form-input
                class="center_align"
                size="sm"
                type="text"
                placeholder="Weight"
                v-model="updating_item.actual_weight_kg"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_weightInput"
            >Cancel</b-btn
          >
          <b-btn class="mt-3" variant="outline-success" @click="weightInput()"
            >OK</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_confirmStockIn" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Are you sure to stock in?</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_confirmStockIn"
            >Cancel</b-btn
          >
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="doStockIn()"
            >Confirm</b-btn
          >
        </div>
      </b-modal>

      <b-modal ref="modal_ExpDateInput" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Product SKU: {{ updating_item.product_sku }}</b-col>
          </b-row>

          <b-row>
            <b-col cols="5"
              ><b-form-input
                class="center_align"
                size="sm"
                type="date"
                placeholder="Expiry Date"
                v-model="updating_item.expiration_date"
              ></b-form-input
            ></b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_ExpDateInput"
            >Cancel</b-btn
          >
          <b-btn class="mt-3" variant="outline-success" @click="doExpDateInput()"
            >OK</b-btn
          >
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const product_fields = [
  {
    key: "product_sku",
    label: "Product SKU"
  },
  {
    key: "product_description",
    label: "Product Description"
  },
  {
    key: "product_qty",
    label: "Quantity"
  }
];

export default {
  name: "OrderMasterDetail",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      location_options: [],
      order_master: false,
      updating_item: {},
      breadcrumb_items: [
        {
          text: "Order Master",
          to: { name: "Order Master" }
        },
        {
          text: "Detail",
          active: true
        }
      ],
      process_mode_options: [
        {
          text: "Simple",
          value: "simple"
        },
        {
          text: "Advanced",
          value: "advanced"
        }
      ],
      inventory_type_options: [
        {
          value: "Active",
          text: "Active"
        },
        {
          value: "Damaged",
          text: "Damaged"
        },
        {
          value: "Hold",
          text: "Hold"
        },
        {
          value: "Expired",
          text: "Expired"
        },
        {
          value: "Committed",
          text: "Committed"
        }
      ],
      process_mode: "advanced",
      order_master_search: {},
      loader: false,
      order_master_products: [],
      stockin_products: [
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        }
      ],
      product_fields: product_fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      total_item_qty: 0,
      fulfil_obj: {
        total_item_qty: 0,
        total_weight: 0,
        actual_total_weight: 0
      },
      updating_item_i: null
    };
  },
  async created() {
    // await this.getOrderMasterDetail();
    // await this.getOrderMasterProduct();
    await this.getWMS_Locations();
    this.initialized = true;
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  methods: {
    async getWMS_Locations() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "wms_location_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      this.location_options = [
        {
          value: "-",
          text: "-"
        }
      ];

      for (let i in response.data.locations) {
        let location_obj = {
          value: response.data.locations[i].location_code,
          text: response.data.locations[i].location_code
        };

        this.location_options.push(location_obj);
      }
    },
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getOrderMasterDetail() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_get.php",
        data: {
          order_number: this.order_master_search.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      if (response.data.orders && response.data.orders.length > 0) {
        let tmp_order_obj = response.data.orders[0];
        if (
          !tmp_order_obj.tracking_obj ||
          tmp_order_obj.tracking_obj.tracking_number == ""
        ) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Invalid Tracking Number"
          });
          return;
        }

        if (tmp_order_obj.stock_status != "committed") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Stock not committed"
          });
          return;
        }

        this.order_master = response.data.orders[0];
      }
    },

    async getOrderMasterProduct() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_product_get.php",
        data: {
          order_number: this.order_master_search.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });

      let total_weight = 0;
      let total_item_qty = 0;
      for (let i in response.data.products) {
        total_weight += parseFloat(response.data.products[i].actual_weight_kg);
        total_item_qty += parseInt(response.data.products[i].product_qty);
      }

      this.fulfil_obj.total_weight = total_weight;
      this.fulfil_obj.total_item_qty = total_item_qty;
      this.order_master_products = response.data.products;
    },

    async lookupProductMaster(row_product, row_product_i) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_get.php",
        data: {
          product_sku: row_product.product_sku,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      if (response.data.products.length > 0) {
        this.stockin_products[row_product_i].product_description =
          response.data.products[0]["product_description_en"];

        this.stockin_products[row_product_i].actual_weight_kg =
          response.data.products[0]["actual_weight_kg"];
        this.stockin_products[row_product_i].height_cm =
          response.data.products[0]["height_cm"];
        this.stockin_products[row_product_i].width_cm =
          response.data.products[0]["width_cm"];
        this.stockin_products[row_product_i].depth_cm =
          response.data.products[0]["depth_cm"];

        this.stockin_products[row_product_i].lot_1 =
          response.data.products[0]["lot_1"];

          this.stockin_products[row_product_i].expiration_date =
          response.data.products[0]["expiration_date"];

        // store all lot# in product, for checking existing lot# or not
        this.stockin_products[row_product_i].lot_nos = [];
        for(let pi in response.data.products){
          this.stockin_products[row_product_i].lot_nos.push(
            response.data.products[pi].lot_1
          );
        }

        this.stockin_products = JSON.parse(
          JSON.stringify(this.stockin_products)
        );
        this.stockin_products[row_product_i].product_qty = 1;

        for (let li in this.location_options) {
          if (
            this.location_options[li].value ==
            response.data.products[0]["default_picking_location"]
          ) {
            this.stockin_products[row_product_i].location =
              response.data.products[0]["default_picking_location"];
            break;
          }
        }

        // focus next row
        // let next_ele_ref =
        //   "txt_product_sku_" +
        //   ((row_product_i + 1) % this.stockin_products.length);
        let next_ele_ref = "txt_quantity_" + row_product_i;
        this.$refs[next_ele_ref][0].$el.focus();

        // add new row if last
        if (row_product_i == this.stockin_products.length - 2) {
          this.stockin_products.push({
            inventory_type: "Active",
            location: "-"
          });
        }
      } else {
        this.stockin_products[row_product_i].product_description = null;
      }
    },

    focusNextRow(row_product_i) {
      let next_ele_ref =
        "txt_product_sku_" +
        ((row_product_i + 1) % this.stockin_products.length);
      this.$refs[next_ele_ref][0].$el.focus();
    },

    async searchOrder() {
      if (this.process_mode == "simple") {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Fulfill Success"
        });
        return;
      }
      await this.getOrderMasterDetail();
      await this.getOrderMasterProduct();
    },

    showModal_confirmStockIn() {
      // check if lot#, chris
      // for(let i in this.stockin_products){
      //   if(this.stockin_products[i].lot_1 == ''){
      //     this.$eventHub.$emit("show_modal_message", {
      //       message_content: 'Please enter Lot#'
      //     });
      //     return;
      //   }
      // }
      this.$refs.modal_confirmStockIn.show();
    },

    hideModal_confirmStockIn() {
      this.$refs.modal_confirmStockIn.hide();
    },

    async lookupProduct(row_product, row_product_i) {
      // see if already exist first
      for (let i in this.stockin_products) {
        if (
          row_product_i != i &&
          this.stockin_products[row_product_i].product_sku ==
            this.stockin_products[i].product_sku
        ) {
          this.stockin_products[i].product_qty++;

          // cancel current input
          this.stockin_products[row_product_i].product_sku = null;

          this.stockin_products = JSON.parse(
            JSON.stringify(this.stockin_products)
          );
          this.checkProductCnt();

          return;
        }
      }

      // lookup in product array
      for (let i in this.order_master_products) {
        let order_master_product = this.order_master_products[i];
        if (
          order_master_product.product_sku ==
          this.stockin_products[row_product_i].product_sku
        ) {
          this.stockin_products[row_product_i].product_description =
            order_master_product.product_description;
          this.stockin_products[row_product_i].product_qty = 1;
          break;
        } else {
          this.stockin_products[row_product_i].product_description = null;
          this.stockin_products[row_product_i].product_qty = null;
        }
      }

      this.stockin_products = JSON.parse(JSON.stringify(this.stockin_products));

      this.checkProductCnt();

      // focus next row
      // let next_ele_ref =
      //   "txt_product_sku_" +
      //   ((row_product_i + 1) % this.stockin_products.length);
      let next_ele_ref = "txt_quantity_" + row_product_i;
      this.$refs[next_ele_ref][0].$el.focus();

      // add new row if last
      if (row_product_i == this.stockin_products.length - 2) {
        this.stockin_products.push({
            inventory_type: "Active",
            location: "-"
          });
      }
    },

    checkProductCnt() {
      let total_cnt = 0;
      let total_weight = 0;
      for (let i in this.stockin_products) {
        let fulfil_product = this.stockin_products[i];
        if (fulfil_product.product_description != null) {
          total_cnt += fulfil_product.product_qty;
        }
      }

      this.fulfil_obj.actual_total_item_qty = total_cnt;
    },

    async doStockIn() {
      

      this.hideModal_confirmStockIn();
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "stockin_process.php",
        data: {
          dn_no: this.order_master_search.dn_no,
          stockin_products: this.stockin_products,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.stockin_products = [
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        }
      ];
      this.order_master_search = {};

      this.loader_full.hide();
    },

    checkTotalWeight() {
      let is_valid_weight = false;
      let weight_diff =
        this.fulfil_obj.total_weight - this.fulfil_obj.actual_total_weight;

      let weight_overhead = 0.5;

      if (
        this.fulfil_obj.actual_total_weight > 0 &&
        weight_diff < weight_overhead &&
        weight_diff > weight_overhead * -1
      ) {
        is_valid_weight = true;
      }

      return is_valid_weight;
    },

    printWaybill() {
      this.printPDF();
      this.updateFulfillStatus();

      this.stockin_products = [
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        },
        {
          inventory_type: "Active",
          location: "-"
        }
      ];
      this.order_master_search = {};
      this.fulfil_obj = {
        total_item_qty: 0,
        total_weight: 0,
        actual_total_weight: 0,
        actual_total_item_qty: 0
      };
    },

    checkProductRowSKUState(row_product) {
      if (row_product.product_sku == null) {
        return null;
      } else {
        return row_product.product_description != null;
      }
    },

    checkProductRowQtyState(row_product, row_product_i) {
      if (row_product.product_sku == null) {
        return null;
      } else {
        // lookup in product array
        for (let i in this.order_master_products) {
          let order_master_product = this.order_master_products[i];
          if (
            order_master_product.product_sku ==
            this.stockin_products[row_product_i].product_sku
          ) {
            // check if qty exact match
            if (
              this.stockin_products[row_product_i].product_qty ==
              order_master_product.product_qty
            ) {
              return true;
            }
            break;
          }
        }

        // qty not found/match
        return false;
      }
    },

    unlockQtyInput(row_product, row_product_i) {
      this.stockin_products[row_product_i].unlock_qty = true;
    },

    showModal_sizeInput(item, item_i) {
      if (!item.product_sku) {
        return;
      }
      this.updating_item = item;
      this.updating_item_i = item_i;
      this.$refs.modal_sizeInput.show();
      // this.updateTracking(item.tracking_number, "Cancelled", null, null);
    },

    hideModal_sizeInput() {
      this.$refs.modal_sizeInput.hide();
    },

    sizeInput() {
      this.stockin_products[this.updating_item_i] = JSON.parse(
        JSON.stringify(this.updating_item)
      );
      this.$refs.modal_sizeInput.hide();
    },

    showModal_weightInput(item, item_i) {
      if (!item.product_sku) {
        return;
      }
      this.updating_item = item;
      this.updating_item_i = item_i;
      this.$refs.modal_weightInput.show();
      // this.updateTracking(item.tracking_number, "Cancelled", null, null);
    },

    hideModal_weightInput() {
      this.$refs.modal_weightInput.hide();
    },

    weightInput() {
      this.stockin_products[this.updating_item_i] = JSON.parse(
        JSON.stringify(this.updating_item)
      );
      this.$refs.modal_weightInput.hide();
    },

    showModal_ExpDateInput(item, item_i) {
      if (!item.product_sku) {
        return;
      }
      this.updating_item = item;
      this.updating_item.expiration_date = moment(item.expiration_date).format('YYYY-MM-DD');
      this.updating_item_i = item_i;
      this.$refs.modal_ExpDateInput.show();
    },

    hideModal_ExpDateInput() {
      this.$refs.modal_ExpDateInput.hide();
    },

    doExpDateInput() {
      console.log(this.updating_item.expiration_date);
      if(!this.updating_item.expiration_date 
      || this.updating_item.expiration_date == ''
      || this.updating_item.expiration_date == 'Invalid date'){
        this.updating_item.expiration_date = null;
      }
      
      this.stockin_products[this.updating_item_i] = JSON.parse(
        JSON.stringify(this.updating_item)
      );
      console.log(this.stockin_products[this.updating_item_i]);
      this.$refs.modal_ExpDateInput.hide();
    },

    async lookupProductLot(row_product, row_product_i) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_get.php",
        data: {
          product_sku: row_product.product_sku,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      if (response.data.products.length > 0) {
        this.stockin_products[row_product_i].product_description =
          response.data.products[0]["product_description_en"];

        this.stockin_products[row_product_i].actual_weight_kg =
          response.data.products[0]["actual_weight_kg"];
        this.stockin_products[row_product_i].height_cm =
          response.data.products[0]["height_cm"];
        this.stockin_products[row_product_i].width_cm =
          response.data.products[0]["width_cm"];
        this.stockin_products[row_product_i].depth_cm =
          response.data.products[0]["depth_cm"];
        this.stockin_products = JSON.parse(
          JSON.stringify(this.stockin_products)
        );
        this.stockin_products[row_product_i].product_qty = 1;

        for (let li in this.location_options) {
          if (
            this.location_options[li].value ==
            response.data.products[0]["default_picking_location"]
          ) {
            this.stockin_products[row_product_i].location =
              response.data.products[0]["default_picking_location"];
            break;
          }
        }

      } else {
        this.stockin_products[row_product_i].product_description = null;
      }
    },

    checkProductRowLotState(row_product) {
      if (row_product.product_sku == null) {
        return null;
      }
      
      let is_lot_exists = false;
      for(let i in row_product.lot_nos){
        let lot_tmp = row_product.lot_nos[i];
        if(lot_tmp == row_product.lot_1){
          is_lot_exists = true;
          break;
        }
      }
      
      return is_lot_exists;
      
    },

    checkProductRowLocationState(row_product) {
      return row_product.location != '';
    },
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dev_test {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/StockinProcess.vue